import useValidationSchema from '../../Hooks/useValidationSchema'
import useConfigTransform from '../../Hooks/useConfigTransform'
import ProgressiveComponent from './Components/ProgressiveComponent'

const ProgressiveField = () => {
  const { getCurrentSchema } = useValidationSchema()
  const { getCurrentTransform } = useConfigTransform()

  return {
    validationSchema: getCurrentSchema('attributes/progressive'),
    configTransform: getCurrentTransform('attributes/progressive'),
    Component: ProgressiveComponent,
    CoVComponent: () => null
  }
}

export default ProgressiveField
